import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useActivePath } from 'shared/hooks/use-active-path';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import { Paths } from 'shared/routes';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

const tabs = [
  {
    label: 'pages.life-area-detail.tabs.summary.label',
    path: Paths.LifeAreaDetail,
  },
  {
    label: 'pages.life-area-detail.tabs.vision.label',
    path: Paths.LifeAreaDetailVision,
  },
  {
    label: 'pages.life-area-detail.tabs.goals.label',
    path: Paths.LifeAreaDetailGoals,
  },
  {
    label: 'pages.life-area-detail.tabs.tasks.label',
    path: Paths.LifeAreaDetailTasks,
  },
];
export const NavigationTabs: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const activePath = useActivePath();

  const activeIndex = useMemo(
    () => tabs.findIndex(({ path }) => path === activePath),
    [activePath],
  );

  return (
    <MuiTabs value={activeIndex} variant="scrollable" scrollButtons={false}>
      {tabs.map(({ label, path }) => (
        <MuiTab
          key={path}
          label={t(label)}
          component={QueryNavLink}
          to={replaceUrlParams(path, { id: id! })}
          iconPosition="end"
          sx={{
            WebkitAppRegion: 'no-drag',
          }}
          replace
          disableRipple
        />
      ))}
    </MuiTabs>
  );
};
